export const environment = {
  production: false,
  apiUrl: 'https://quality-gate-api-dev.enacloud.me',

  apiUrlBuffer: '',

  client: '',
  redirectUri: 'http://localhost:4200',
  authority: '',
};
